import { protectedLoader } from './protectLoader'
import { LoaderFunctionArgs } from 'react-router-dom'
import {
  CUSTOMER_ADMIN,
  CUSTOMER_SUPPORT,
  DISTRIBUTOR_ADMIN,
  DISTRIBUTOR_SUPPORT,
  HOLDER,
  LIVOX_USER,
  PORTAL_ADMIN,
  PORTAL_SUPPORT,
  SPONSOR,
} from '.'
import { lazyRoute } from '../utils/lazyRoute'

const authUserRoutes = [
  {
    path: '/',
    lazy: lazyRoute(() => import('../pages/Portal/Home')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
          SPONSOR,
        ],
      }),
  },
  {
    path: '*',
    lazy: lazyRoute(() => import('../pages/Portal/NotFound')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
          SPONSOR,
        ],
      }),
  },
  {
    path: '/login',
    lazy: lazyRoute(() => import('../pages/Portal/Login'), 'Login'),
  },
  {
    path: '/forgot-password',
    lazy: lazyRoute(
      () => import('../pages/Portal/ForgotPassword'),
      'ForgotPassword',
    ),
  },
  {
    path: '/reset-password/:token',
    lazy: lazyRoute(
      () => import('../pages/Portal/ResetPasswordToken'),
      'ResetPassword',
    ),
  },
  {
    path: '/logout',
    lazy: lazyRoute(() => import('../pages/Portal/Logout')),
  },
  {
    path: '/unauthorized',
    lazy: lazyRoute(() => import('../pages/Portal/Unauthorized')),
  },
  {
    path: '/profile',
    lazy: lazyRoute(() => import('../pages/Portal/Profile')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
          SPONSOR,
        ],
      }),
  },
  {
    path: '/portal-users',
    lazy: lazyRoute(() => import('../pages/Portal/PortalUsers')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
]

export default authUserRoutes
